import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import BanGiaoTaiSanService from "services/Asset/BanGiao/Index";

export const createUpdate = createAsyncThunk(
  "BanGiaoTaiSan/createUpdate",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await BanGiaoTaiSanService.CreateUpdate(data);
      if (response.data) {
        if (onSuccess) onSuccess(response.data);
      }
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const getDsThongTinPhieu = createAsyncThunk(
  "BanGiaoTaiSan/getDsThongTinPhieu",
  async (data, { rejectWithValue }) => {
    try {
      const response = await BanGiaoTaiSanService.GetAll(data);
      return response.data.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);


export const getThongTinPhieu = createAsyncThunk(
  "BanGiaoTaiSan/getThongTinPhieu",
  async (data, { rejectWithValue }) => {
    try {
        const  {id, onSuccess}= data
        console.log(data,"data")
      const response = await BanGiaoTaiSanService.GetThongTinPhieu(id);
      if (onSuccess) onSuccess(response.data)
      return response.data.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const deletePhieuById = createAsyncThunk(
  "BanGiaoTaiSan/deletePhieuById",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess,id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await BanGiaoTaiSanService.DeletePhieu(id);
      if (response.data) {
        if (onSuccess) onSuccess(response);
      }
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);


// chitiet

export const danhSachTaiSanBanGiao = createAsyncThunk(
  "BanGiaoTaiSan/danhSachTaiSanBanGiao",
  async (data, { rejectWithValue }) => {
    try {
      const  {banGiaoId} = data
      const response = await BanGiaoTaiSanService.DanhSachTaiSanBanGiao(banGiaoId);
      return response.data.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);


export const createUpdateChiTiet = createAsyncThunk(
  "BanGiaoTaiSan/createUpdateChiTiet",
  async (data, { rejectWithValue }) => {
    try {
      const  {onSuccess} = data
      const response = await BanGiaoTaiSanService.CreateUpdateChiTiet(data);
      if (onSuccess) onSuccess(response.data)
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const deleteChiTiet = createAsyncThunk(
  "BanGiaoTaiSan/deleteChiTiet",
  async (data, { rejectWithValue }) => {
    try {
      const  {onSuccess,id} = data
      const response = await BanGiaoTaiSanService.DeleteChiTiet(id);
      if (onSuccess) onSuccess(response.data)
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const getTaiSanChuaBanGiaoSauSuaChua = createAsyncThunk(
  "BanGiaoTaiSan/getTaiSanChuaBanGiaoSauSuaChua",
  async (data, { rejectWithValue }) => {
    try {
      const response = await BanGiaoTaiSanService.GetTaiSanChuaBanGiaoSauSuaChua(data);
      return response.data.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);



const initialState = {
  loading: false,
  BanGiaoTaiSanDetail: {},
  DanhSachPhieuBanGiao: [],
  DanhSachTaiSanBanGiao : [],
  DanhSachTaiSanCoTheBanGiao: []
};

const BanGiaoTaiSanSlice = createSlice({
  name: "banGiaoTaiSan",
  initialState,
  reducers: {
    resetBanGiaoTaiSanDetail: (state, action) => {
      state.BanGiaoTaiSanDetail = {};
    },
    resetDanhSachTaiSanBanGiao: (state, action) => {
      state.DanhSachTaiSanBanGiao = [];
    },
    updateRowChiTietTaiSanBanGiao: (state, action) => {
      var data = cloneDeep(action.payload);
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      delete payload.onError;
      state.DanhSachTaiSanBanGiao = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUpdate.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createUpdate.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getDsThongTinPhieu.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDsThongTinPhieu.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhSachPhieuBanGiao = action.payload;

      })
      .addCase(getDsThongTinPhieu.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getThongTinPhieu.pending, (state) => {
        state.loading = true;
      })
      .addCase(getThongTinPhieu.fulfilled, (state, action) => {
        state.loading = false;
        state.BanGiaoTaiSanDetail = action.payload;

      })
      .addCase(getThongTinPhieu.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deletePhieuById.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePhieuById.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(deletePhieuById.rejected, (state) => {
        state.loading = false;
      })

      .addCase(danhSachTaiSanBanGiao.pending, (state) => {
        state.loading = true;
      })
      .addCase(danhSachTaiSanBanGiao.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhSachTaiSanBanGiao = action.payload;

      })
      .addCase(danhSachTaiSanBanGiao.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deleteChiTiet.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteChiTiet.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteChiTiet.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getTaiSanChuaBanGiaoSauSuaChua.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTaiSanChuaBanGiaoSauSuaChua.fulfilled, (state, action) => {
        state.loading = false;
        state.DanhSachTaiSanCoTheBanGiao = action.payload;
      })
      .addCase(getTaiSanChuaBanGiaoSauSuaChua.rejected, (state) => {
        state.loading = false;
      })

      ;
  },
});
export const {  resetBanGiaoTaiSanDetail, resetDanhSachTaiSanBanGiao, updateRowChiTietTaiSanBanGiao } = BanGiaoTaiSanSlice.actions;

export default BanGiaoTaiSanSlice.reducer;
